import { render } from "./product-slides.vue?vue&type=template&id=7ea8643e"
import script from "./product-slides.vue?vue&type=script&lang=js"
export * from "./product-slides.vue?vue&type=script&lang=js"

import "./product-slides.vue?vue&type=style&index=0&id=7ea8643e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__